import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M4 10v8a1 1 0 0 0 1 1h2V9H5a1 1 0 0 0-1 1m5-1v10h6.646a2 2 0 0 0 1.857-1.257l2.4-6A2 2 0 0 0 18.046 9H15c1-3 0-5-2-5a2 2 0 0 0-2 2v1a2 2 0 0 1-2 2"
    }
  )
);
var SvgThumbsUpFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ThumbsUpFilled_default = SvgThumbsUpFilled;

export { ThumbsUpFilled_default as default };
